import FinanceApi from "@/services/FinanceApi";

const getAll = async (config) => {
    return FinanceApi.get('/banks', config);
}
const get = async (id) => {
    return FinanceApi.get('/banks/' + id);
}
const store = async (data) => {
    return FinanceApi.post('/banks', data);
}
const update = async (id, formData) => {
    return FinanceApi.put('/banks/' + id, formData);
}
const del = async (id) => {
    return FinanceApi.delete('/banks/' + id);
}

export default {
    getAll,
    get,
    update,
    store,
    del,
}
